define((require) => {
    "use strict";

    const _                        = require("underscore");
    const FontDescriptorCollection = require("shared/data/fonts/FontDescriptorCollection");
    const FontProvider             = require("shared/data/fonts/FontProvider");
    const WebFontVariants          = require("shared/ui/experience/fonts/WebFontVariants").default;

    /*
     * @type {FontDescriptorCollection}
     */
    let fontDescriptorCollection = null;

    /**
     * An object containing a list of all standard fonts, including their aliases.
     *
     * @class StandardWebFontList
     *
     * @author Bruce Mackenzie Nielsen
     * @author Kim
     */
    const StandardWebFontList = {

        collection() {
            if (fontDescriptorCollection) {
                return fontDescriptorCollection;
            }

            const variations = _.map(WebFontVariants.get(FontProvider.STANDARD), (variant) => variant.value);

            const descriptors = StandardWebFontList.items.map((item) => ({
                provider: FontProvider.STANDARD,
                name: item.family,
                family: item.family,
                cssFamily: StandardWebFontList.cssFamilyNames(item),
                variations
            }));

            fontDescriptorCollection = new FontDescriptorCollection(descriptors);

            return fontDescriptorCollection;
        },

        /**
         * Convenience method for constructing the CSS font family for a given font family string. <p>
         *
         * For an unknown <tt>value</tt>, <tt>value</tt> is simply returned as-is.
         *
         * @param  {String|Object} value The font family string, e.g. <tt>"Palatino Linotype"</tt>.
         * @return {String} The CSS family string, e.g. <tt>"Palatino Linotype, Book Antiqua, Palatino, serif"</tt>.
         *                  Will be <tt>value</tt> as-is if <tt>value</tt> is unknown.
         */
        cssFamilyNames(value) {
            let css  = value;
            const item = _.isObject(value) ? value : _.find(StandardWebFontList.items, (item) => {
                if (value.toLowerCase() === item.family.toLowerCase()) {
                    return true;
                }
                // Look for a possible alias
                const aliases = _.invoke(item.aliases, "toLowerCase");
                return _.contains(aliases, value.toLowerCase());
            });

            if (item) {
                css = item.family;

                item.aliases.forEach((alias) => {
                    css += `,${alias}`;
                });

                css += `,${item.genericFamily}`;
            }

            return css;
        },

        items: [
            {
                family: "Arial",
                aliases: [
                    "Helvetica"
                ],
                genericFamily: "sans-serif"
            },
            {
                family: "Arial Black",
                aliases: [
                    "Gadget"
                ],
                genericFamily: "sans-serif"
            },
            {
                family: "Courier New",
                aliases: [],
                genericFamily: "monospace"
            },
            {
                family: "Georgia",
                aliases: [],
                genericFamily: "serif"
            },
            {
                family: "Lucida Sans Unicode",
                aliases: [
                    "Lucida Grande"
                ],
                genericFamily: "sans-serif"
            },
            {
                family: "Palatino Linotype",
                aliases: [
                    "Book Antiqua",
                    "Palatino"
                ],
                genericFamily: "serif"
            },
            {
                family: "Tahoma",
                aliases: [
                    "Geneva"
                ],
                genericFamily: "sans-serif"
            },
            {
                family: "Times New Roman",
                aliases: [
                    "Times"
                ],
                genericFamily: "serif"
            },
            {
                family: "Trebuchet MS",
                aliases: [],
                genericFamily: "sans-serif"
            },
            {
                family: "Verdana",
                aliases: [
                    "Geneva"
                ],
                genericFamily: "sans-serif"
            }
        ],

        reset() {
            fontDescriptorCollection = null;
        }
    };

    return StandardWebFontList;
});



// WEBPACK FOOTER //
// ./src/shared/ui/assets/StandardWebFontList.js